<template>
  <div class="d-inline-block" style="break-inside: avoid">
    <label
      :tabindex="tabindex"
      :class="{
        'trigger-margin': !noMargin,
        'popup-disabled': disabled,
      }"
      class="trigger"
      :style="cursor ? `cursor: ${cursor}` : undefined"
    >
      <i v-if="!disabled && faIcon" :class="`fa ${faIcon} mr-1`" />
      <slot name="label" />
    </label>

    <div
      v-if="!isStatic"
      ref="popup"
      class="popup"
      :class="[
        {
          shadowed: !noShadow,
          center,
        },
        contentClass,
      ]"
      :style="contentStyle"
    >
      <slot name="content" />
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  contentStyle?: string
  contentClass?: string
  noShadow?: boolean
  faIcon?: 'fa-info-circle' | 'fa-flask' | 'fa-trash' | 'fa-upload' | 'fa-times' | 'fa-unlock' | 'fa-lock' | 'fa-warning' | ''
  noMargin?: boolean
  tabindex?: string
  center?: boolean
  disabled?: boolean
  isStatic?: boolean // whether there is no content (couldn't get slotsHasContent to work)
  cursor?: string
}

withDefaults(defineProps<Props>(), {
  faIcon: 'fa-info-circle',
  tabindex: '0',
})
</script>

<style lang="scss" scoped>
@use '@/styles/popup.scss';

.trigger-margin {
  margin: 0 0.5em;
}

.trigger {
  margin: 0;
  font-weight: bold;
  // cursor: help;

  &.popup-disabled {
    cursor: auto;
  }

  &:not(.popup-disabled):focus {
    color: blue;
    outline: none;
  }

  &:not(.popup-disabled) {
    &:focus + .popup,
    &:hover + .popup {
      display: block;
    }
  }
}

.popup {
  white-space: pre-line;

  &.shadowed {
    box-shadow: 1px 2px 10px #0004;
  }

  &.right {
    right: 0;
  }
}

.center {
  transform: translate(-50%);
}
</style>
